module.exports = __webpack_public_path__ + "static/redlining-912ad948c3320bbd020f67aba6d7c7ff.jpg";